module.exports = __webpack_public_path__ + "img/FJ.ff52a145.png";